/** ປ້າຍພາສາລາວ ສຳລັບ performance-tracking (ຄ້າຍ trainingLaoLabels ສຳລັບ checklist) */

import { ASSIGNED_TASK_DUE_SOON_DAYS } from "../../domain/task-alert";

export function labelAssignedTaskAlertStatus(status: string): string {
  switch (status) {
    case "overdue":
      return "ເກີນກຳນົດ";
    case "due_soon":
      return `ໃກ້ຄົບກຳນົດ (≤ ${ASSIGNED_TASK_DUE_SOON_DAYS} ວັນ)`;
    case "none":
    default:
      return "";
  }
}

/** ຄວາມສຳຄັນວຽກໂຄງການ (mgmt_project_task.priority) */
export function labelProjectTaskPriority(
  p: "high" | "medium" | "low" | null,
): string {
  switch (p) {
    case "high":
      return "ສູງ";
    case "medium":
      return "ກາງ";
    case "low":
      return "ຕ່ຳ";
    default:
      return "";
  }
}
